import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  EVIconButton,
  EVTooltip,
  EVCircularProgress,
  EVDialog,
  EVDialogTitle,
  EVDialogContent,
  EVDialogContentText,
  EVDialogActions,
  EVButton,
  EVDeleteIcon,
} from '@eagleview/ev-comp-library';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { DELETE_DATE_OF_LOSS } from 'layout/adjuster/Adjuster.constants';
import { deleteDateOfLossAction } from '../../Adjuster.actions';
import useStyles from '../AdjusterSidePanel.styles';

const DeleteDateOfLoss = ({ orderID, policyDateOfLoss }) => {
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const styles = useStyles();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const loading = useSelector((state) => state.adjusterReducer.loading);

  const handleDeleteOpen = () => setShowDeleteDialog(true);
  const handleDeleteClose = () => setShowDeleteDialog(false);

  const handleDeleteConfirm = () => {
    dispatch(deleteDateOfLossAction({ orderId: orderID }));
    setShowDeleteDialog(false);
  };

  return (
    <>
      <EVTooltip
        title={policyDateOfLoss ? t('adjusterToolbarTooltip.deleteDateOfLoss') : t('adjusterToolbarTooltip.noDateOfLoss')}
      >
        {loading[DELETE_DATE_OF_LOSS] ? (
          <EVCircularProgress size={24} />
        ) : (
          <EVIconButton
            id="deleteDateOfLoss"
            size="small"
            data-testid="deleteDateOfLossBtn"
            disabled={!policyDateOfLoss}
            onClick={handleDeleteOpen}
          >
            <EVDeleteIcon />
          </EVIconButton>
        )}
      </EVTooltip>

      <EVDialog
        open={showDeleteDialog}
        onClose={handleDeleteClose}
        PaperProps={{ className: styles.deleteDialogPaper }}
      >
        <EVDialogTitle>{t('adjuster.deleteDateOfLossDialogTitle')}</EVDialogTitle>
        <EVDialogContent>
          <EVDialogContentText>{t('adjuster.deleteDateOfLossDialogContent')}</EVDialogContentText>
        </EVDialogContent>
        <EVDialogActions>
          <EVButton onClick={handleDeleteClose} disabled={loading[DELETE_DATE_OF_LOSS]}>
            {t('cancel')}
          </EVButton>
          <EVButton
            onClick={handleDeleteConfirm}
            color="primary"
            autoFocus
            disabled={loading[DELETE_DATE_OF_LOSS]}
          >
            {loading[DELETE_DATE_OF_LOSS] ? <EVCircularProgress size={20} /> : t('delete')}
          </EVButton>
        </EVDialogActions>
      </EVDialog>
    </>
  );
};

DeleteDateOfLoss.propTypes = {
  orderID: PropTypes.string.isRequired,
  policyDateOfLoss: PropTypes.string,
};

DeleteDateOfLoss.defaultProps = {
  policyDateOfLoss: null,
};

export default DeleteDateOfLoss;
